export interface ExpressOrderError {
  code?: string;
  field?: string;
  message?: string;
}

export class ExpressOrderUpdateError extends Error {
  readonly errors: ExpressOrderError[];
  readonly status: number;

  constructor(status: number, statusText: string, errors: ExpressOrderError[]) {
    super(`HTTP ${status}: ${statusText}`);
    this.name = 'ExpressOrderUpdateError';
    this.status = status;
    this.errors = errors;
  }
}

export const assertExpressOrderUpdateSucceeded = async (
  response: Response,
): Promise<void> => {
  if (response.ok) return;

  let errors: ExpressOrderError[] = [];

  try {
    const body = (await response.json()) as { errors?: ExpressOrderError[] };
    if (Array.isArray(body.errors)) errors = body.errors;
  } catch {
    // The HTTP status still represents a failed update when no JSON is present.
  }

  throw new ExpressOrderUpdateError(
    response.status,
    response.statusText,
    errors,
  );
};

export const getExpressOrderErrorDetails = (error: unknown) =>
  error instanceof ExpressOrderUpdateError
    ? error.errors.map(({ code, field }) => ({ code, field }))
    : [];

export const parseExpressRequestBody = <Body>(body: Body | string): Body => {
  const parsed = typeof body === 'string' ? JSON.parse(body) : body;

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new SyntaxError('Expected a JSON object');
  }

  return parsed as Body;
};
